<!-- 合作伙伴主数据新增 -->
<template>
  <div class="addCooperation main-content">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <!-- <el-collapse-item name="1"> -->
      <!--基本信息-->
      <!-- <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template> -->
      <!-- <div class="collapse-content"> -->
      <!-- 顶部表单 -->
      <div class="topData">
        <el-form :model="topData" :rules="rules" ref="topData" label-width="120px">
          <el-row :gutter="24">
            <!-- 公司code -->
            <el-col :span="6">
              <el-form-item :label="$t('cooperation.label.companyCode')" prop="companyCode">
                <el-input
                  :placeholder="$t('cooperation.placeholder.companyCode')"
                  disabled
                  v-model="topData.companyCode"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 公司名称 -->
            <el-col :span="6">
              <el-form-item :label="$t('cooperation.label.companyName')" prop="companyName">
                <el-input
                  :placeholder="$t('cooperation.placeholder.companyName')"
                  disabled
                  v-model="topData.companyName"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 业务部门 -->
              <el-form-item label="部门名称" prop="departmentCode">
                <el-select
                  required
                  clearable
                  v-model="topData.departmentCode"
                  filterable
                  @change="changeDearptment"
                >
                  <el-option
                    v-for="item in departmentList"
                    :key="item.personDepartmentCode"
                    :label="item.personDepartmentName"
                    :value="item.personDepartmentCode"
                  >
                  </el-option>
                </el-select>
                <!-- <el-input :placeholder="$t('cooperation.placeholder.departmentCode')" disabled v-model="topData.departmentName"></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 申请时间 -->
              <el-form-item :label="$t('cooperation.label.requestTime')" prop="requestTime">
                <el-input disabled v-model="topData.requestTime"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <!-- 合作伙伴编码 -->
            <el-col :span="6">
              <el-form-item :label="$t('cooperation.label.partnerCode')" prop="partnerCode">
                <el-input
                  disabled
                  v-model="topData.partnerCode"
                  :placeholder="$t('cooperation.placeholder.autoProduction')"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- 创建人 -->
            <el-col :span="6">
              <el-form-item :label="$t('cooperation.label.createBy')" prop="createBy">
                <el-select disabled clearable v-model="topData.createBy" filterable>
                  <el-option
                    v-for="item in requestByList"
                    :key="item.id"
                    :label="item.personName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 业务负责人 -->
            <el-col :span="6">
              <el-form-item label="业务负责人" prop="busnessPersonName">
                <search-table
                  v-model="topData.busnessPersonName"
                  searchType="personnel"
                  :isMultiple="true"
                  :extraData="{ personCompanyCode: this.userInfo.companyCode }"
                  :currentValue="topData.busnessPersonName || null"
                  :checkRowKeys="[topData.businessPersonNo]"
                  @input="setBusinessPerson"
                ></search-table>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- </div> -->
      <!-- </el-collapse-item> -->
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <el-form :model="baseData" :rules="rules" ref="baseData" label-width="140px">
            <el-row :gutter="10">
              <!-- 合作伙伴名称 -->
              <el-col :span="6">
                <el-form-item label="合作伙伴名称" prop="partnerZhName">
                  <el-tooltip
                    :disabled="!baseData.partnerZhName"
                    class="item"
                    effect="dark"
                    :content="String(baseData.partnerZhName)"
                    placement="top"
                  >
                    <el-input
                      placeholder="请输入"
                      v-model="baseData.partnerZhName"
                      clearable
                      required
                      maxlength="50"
                      @blur="formatPartnerName"
                    ></el-input>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="合作伙伴简称" prop="abbreviation">
                  <el-input
                    placeholder="请输入"
                    v-model="baseData.abbreviation"
                    clearable
                    maxlength="50"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.creditCode')" prop="creditCode">
                  <el-input
                    @blur="handleInputHover('creditCode')"
                    :placeholder="$t('cooperation.placeholder.creditCode')"
                    v-model.trim="baseData.creditCode"
                    clearable
                    :disabled="baseData.ifPersonalPartner == 1"
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 合作伙伴类型 -->
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.partnerType')" prop="partnerType">
                  <el-select
                    filterable
                    @change="partnerTypeChange"
                    :placeholder="$t('cooperation.placeholder.pleaseSelect')"
                    v-model="baseData.partnerType"
                    clearable
                  >
                    <el-option
                      v-for="item of partnerTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <!-- 个人合作伙伴 -->
              <el-col :span="6">
                <el-form-item
                  :label="$t('cooperation.label.ifPersonalPartner')"
                  prop="ifPersonalPartner"
                >
                  <el-select
                    filterable
                    @change="resolveRules"
                    :placeholder="$t('cooperation.placeholder.pleaseSelect')"
                    v-model="baseData.ifPersonalPartner"
                    clearable
                  >
                    <el-option :label="$t('cooperation.label.yes')" value="1"></el-option>
                    <el-option :label="$t('cooperation.label.no')" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 授信合作伙伴 -->
              <el-col :span="6">
                <el-form-item
                  :label="$t('cooperation.label.ifCreditPartner')"
                  prop="ifCreditPartner"
                >
                  <el-select
                    filterable
                    :placeholder="$t('cooperation.placeholder.pleaseSelect')"
                    v-model="baseData.ifCreditPartner"
                    clearable
                  >
                    <el-option :label="$t('cooperation.label.yes')" value="1"></el-option>
                    <el-option :label="$t('cooperation.label.no')" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 关联合作伙伴 -->
              <el-col :span="6">
                <el-form-item label="关联合作伙伴" prop="associatePartner">
                  <search-table
                    v-model="baseData.associatedPartnerName"
                    searchType="partnerParent"
                    :isMultiple="false"
                    :extraData="{ partnerCode: topData.partnerCode }"
                  ></search-table>
                </el-form-item>
              </el-col>
              <!-- 合作伙伴类别 -->
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.partnerForm')" prop="partnerForm">
                  <el-select
                    filterable
                    v-model="baseData.partnerForm"
                    :placeholder="$t('cooperation.placeholder.partnerForm')"
                    clearable
                  >
                    <el-option
                      v-for="item of partnerFormList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <!-- 法人 -->
              <el-col :span="6">
                <el-form-item label="法定代表人" prop="legalPerson">
                  <el-input
                    :placeholder="$t('cooperation.placeholder.legalPerson')"
                    v-model="baseData.legalPerson"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 法人类型 -->
              <el-col :span="6">
                <el-form-item
                  :label="$t('cooperation.label.legalEntityType')"
                  prop="legalEntityType"
                >
                  <el-select
                    v-model="baseData.legalEntityType"
                    :placeholder="$t('cooperation.placeholder.legalEntityType')"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item of legalList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 身份证号 -->
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.identityNo')" prop="identityNo">
                  <el-input
                    @blur="handleInputHover('identityNo')"
                    :placeholder="$t('cooperation.placeholder.identityNo')"
                    v-model.trim="baseData.identityNo"
                    :disabled="baseData.ifPersonalPartner != '1'"
                    clearable
                    maxlength="50"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.taxpayerType')" prop="taxpayerType">
                  <el-select
                    filterable
                    v-model="baseData.taxpayerType"
                    :placeholder="$t('cooperation.placeholder.taxpayerType')"
                    clearable
                  >
                    <el-option
                      v-for="item of taxpayerTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="经营范围" prop="businessScope">
                  <el-tooltip
                    :disabled="!baseData.businessScope"
                    class="item"
                    effect="dark"
                    :content="String(baseData.businessScope)"
                    placement="top"
                  >
                    <el-input
                      placeholder="请输入"
                      v-model="baseData.businessScope"
                      clearable
                      maxlength="1000"
                    ></el-input>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="营业执照经营范围" prop="licenseScope">
                  <el-tooltip
                    :disabled="!baseData.licenseScope"
                    class="item"
                    effect="dark"
                    :content="String(baseData.licenseScope)"
                    placement="top"
                  >
                    <el-input
                      placeholder="请输入"
                      v-model="baseData.licenseScope"
                      clearable
                      maxlength="1000"
                    ></el-input>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="许可证经营范围" prop="permitScope">
                  <el-tooltip
                    :disabled="!baseData.permitScope"
                    class="item"
                    effect="dark"
                    :content="String(baseData.permitScope)"
                    placement="top"
                  >
                    <el-input
                      placeholder="请输入"
                      v-model="baseData.permitScope"
                      clearable
                      maxlength="1000"
                    ></el-input>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <!-- 许可证有效期限 -->
              <el-col :span="6">
                <el-form-item label="许可证有效期限" prop="licenseValid">
                  <el-date-picker
                    v-model="baseData.licenseValid"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择"
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <!-- 成立日期 -->
              <el-col :span="6">
                <el-form-item
                  :label="$t('cooperation.label.establishedDate')"
                  prop="establishedDate"
                >
                  <el-date-picker
                    v-model="baseData.establishedDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$t('cooperation.placeholder.establishedDate')"
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="登记机关" prop="registrationAuthority">
                  <el-input
                    placeholder="请输入"
                    v-model="baseData.registrationAuthority"
                    clearable
                    maxlength="64"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <!-- 核准日期 -->
              <el-col :span="6">
                <el-form-item label="核准日期" prop="approvalTime">
                  <el-date-picker
                    v-model="baseData.approvalTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="请输入核准日期"
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <!-- 注册资本 -->
              <el-col :span="6">
                <el-row :gutter="10">
                  <el-col :span="18">
                    <el-form-item
                      :label="$t('cooperation.label.registeredAssets')"
                      prop="registeredAssets"
                    >
                      <input-number
                        :max="99999999999.999999"
                        :precision="6"
                        :placeholder="$t('cooperation.placeholder.registeredAssets')"
                        v-model="baseData.registeredAssets"
                        clearable
                      >
                      </input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item class="isShowLabel" prop="currencyType">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="getSelectLabel(baseData.currencyType) + ''"
                        placement="top"
                        :disabled="!baseData.currencyType"
                      >
                        <el-select
                          filterable
                          v-model="baseData.currencyType"
                          :placeholder="$t('cooperation.placeholder.currencyType')"
                          clearable
                        >
                          <el-option
                            v-for="item of tradeCurrencyList"
                            :key="item.id"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-tooltip>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <!-- 实缴资本 -->
              <!-- 新加字段 -->
              <el-col :span="6">
                <el-row :gutter="10">
                  <el-col :span="18">
                    <el-form-item label="实缴资本(万)" prop="actualAssets">
                      <input-number
                        :max="99999999999.999999"
                        :precision="6"
                        :placeholder="$t('cooperation.placeholder.registeredAssets')"
                        v-model="baseData.actualAssets"
                        clearable
                      >
                      </input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item class="isShowLabel" prop="currencyType">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="getSelectLabel(baseData.currencyType) + ''"
                        placement="top"
                        :disabled="!baseData.currencyType"
                      >
                        <el-select
                          filterable
                          v-model="baseData.currencyType"
                          :placeholder="$t('cooperation.placeholder.currencyType')"
                          clearable
                        >
                          <el-option
                            v-for="item of tradeCurrencyList"
                            :key="item.id"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-tooltip>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="6">
                <el-form-item label="营业期限" prop="businessTerm">
                  <el-input
                    placeholder="请输入"
                    v-model="baseData.businessTerm"
                    clearable
                    maxlength="64"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 行业 -->
              <el-col :span="12">
                <el-form-item :label="$t('cooperation.label.industryName')" prop="industryName">
                  <el-select
                    filterable
                    v-model="baseData.industryName"
                    :placeholder="$t('cooperation.placeholder.industryName')"
                    clearable
                  >
                    <el-option
                      style="width: 100%"
                      v-for="item of industryList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <!-- 企业类型 -->
              <el-col :span="12">
                <el-form-item :label="$t('cooperation.label.enterpriseType')" prop="enterpriseType">
                  <el-select
                    filterable
                    v-model="baseData.enterpriseType"
                    :placeholder="$t('cooperation.placeholder.enterpriseType')"
                    clearable
                  >
                    <el-option
                      v-for="item of enterpriseTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 是否为关联方 -->
              <el-col :span="6">
                <el-form-item label="是否为关联方（是否为集团客户）" prop="isRelatedParty">
                  <el-select
                    filterable
                    v-model="baseData.isRelatedParty"
                    @change="changeRelated"
                    placeholder="请选择是否为关联方"
                    clearable
                  >
                    <el-option
                      style="width: 100%"
                      v-for="item of yesnoList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 发票类型 -->
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.taxType')" prop="taxType">
                  <el-select
                    v-model="baseData.taxType"
                    @change="resolveRules"
                    :placeholder="$t('cooperation.placeholder.taxType')"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item of taxTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <!-- 交易币种 -->
              <el-col :span="6">
                <el-form-item :label="$t('cooperation.label.tradeCurrency')" prop="tradeCurrency">
                  <el-select
                    filterable
                    v-model="baseData.tradeCurrency"
                    :placeholder="$t('cooperation.placeholder.tradeCurrency')"
                    clearable
                  >
                    <el-option
                      v-for="item of tradeCurrencyList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            开票信息
          </div>
        </template>
        <div class="collapse-content">
          <el-form :model="baseData1" :rules="rules" ref="baseData1" label-width="140px">
            <el-row :gutter="10">
              <!-- 开票地址 -->
              <el-col :span="12">
                <el-form-item :label="$t('cooperation.label.invoiceAddress')" prop="invoiceAddress">
                  <el-input
                    :placeholder="$t('cooperation.placeholder.invoiceAddress')"
                    v-model="baseData1.invoiceAddress"
                    clearable
                    maxlength="64"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 开票电话 -->
              <el-col :span="12">
                <el-form-item :label="$t('cooperation.label.invoicePhone')" prop="invoicePhone">
                  <el-input
                    :placeholder="$t('cooperation.placeholder.invoicePhone')"
                    v-model="baseData1.invoicePhone"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 开票银行名称 -->
              <el-col :span="12">
                <el-form-item
                  :label="$t('cooperation.label.invoiceBankName')"
                  prop="invoiceBankName"
                >
                  <el-input
                    :placeholder="$t('cooperation.placeholder.invoiceBankName')"
                    v-model="baseData1.invoiceBankName"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 开票银行账户 -->
              <el-col :span="12">
                <el-form-item label="开票银行账户" prop="invoiceBankAccount">
                  <el-input
                    :placeholder="$t('cooperation.placeholder.invoiceBankAccount')"
                    v-model="baseData1.invoiceBankAccount"
                    clearable
                    maxlength="32"
                    @input="invoiceBankAccountInput"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="10">
              <!-- 国内合作伙伴 -->
              <el-col :span="6">
                <el-form-item label="国家地区" prop="ifDomestic">
                  <el-select
                    @change="resolveRules($event, 'ifDomestic')"
                    :placeholder="$t('cooperation.placeholder.pleaseSelect')"
                    v-model="baseData1.ifDomestic"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item of countryList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 省份/城市 -->
              <el-col :span="6">
                <template v-if="baseData1.ifDomestic === this.$globalVar.CHNCode">
                  <el-row :gutter="24" class="province-city">
                    <el-col :span="14" style="padding-right: 0">
                      <el-form-item label="省市" prop="province">
                        <el-select
                          filterable
                          v-model="baseData1.province"
                          @change="handleProvinceChange"
                          :placeholder="$t('cooperation.placeholder.province')"
                          clearable
                        >
                          <el-option
                            v-for="item of provinceList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item class="isShowLabel" prop="city">
                        <el-select
                          filterable
                          v-model="baseData1.city"
                          @change="handleCityChange"
                          :placeholder="$t('cooperation.placeholder.city')"
                          clearable
                        >
                          <el-option
                            v-for="item of cityList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
              </el-col>
              <!-- 街道地址/门牌号 -->
              <el-col :span="12">
                <el-form-item label="详细地址" prop="streetAddress">
                  <el-input
                    v-model="baseData1.streetAddress"
                    placeholder="请输入详细地址"
                    clearable
                    maxlength="32"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <template v-if="showDeliverSection">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="投送人姓名" prop="delivererName">
                    <el-input
                      v-model="baseData1.delivererName"
                      placeholder="请输入"
                      clearable
                      maxlength="32"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="投送人电话" prop="delivererPhone">
                    <el-input
                      v-model="baseData1.delivererPhone"
                      placeholder="请输入"
                      clearable
                      maxlength="32"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="投送人身份证号" prop="delivererIdNo">
                    <el-input
                      v-model="baseData1.delivererIdNo"
                      placeholder="请输入身份证号"
                      clearable
                      maxlength="32"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-row :gutter="12">
                  <el-col :span="6">
                    <el-form-item label="投送人身份证期限" prop="delivererIdDurationStart">
                      <el-date-picker
                        v-model="baseData1.delivererIdDurationStart"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="请输入"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="至" prop="delivererIdDurationEnd">
                      <el-date-picker
                        v-model="baseData1.delivererIdDurationEnd"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="请输入"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-col :span="12">
                  <el-form-item label="投送人地址" prop="delivererAddress">
                    <el-input
                      v-model="baseData1.delivererAddress"
                      placeholder="请输入地址"
                      clearable
                      maxlength="32"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>

            <el-row>
              <el-col :span="10">
                <el-form-item :label="$t('cooperation.label.mark')" prop="mark">
                  <el-input
                    :placeholder="$t('cooperation.placeholder.mark')"
                    v-model="baseData1.mark"
                    clearable
                    maxlength="80"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            银行信息
          </div>
        </template>
        <div class="collapse-content">
          <!-- 银行数据表格 -->
          <div class="tableStyle">
            <vxe-grid
              border
              show-overflow
              resizable
              ref="partnersBanks"
              class="vxe-table-element"
              size="mini"
              align="center"
              :auto-resize="true"
              :data="baseData.partnersBanks"
              :columns="bankColumnList"
              :edit-rules="bankTableEditRules"
              :toolbar="{}"
              :edit-config="{ trigger: 'click', mode: 'row' }"
              :valid-config="{ autoPos: true, message: 'inline' }"
            >
              <template v-slot:buttons>
                <vxe-button
                  @click="$refs.partnersBanks.commitProxy('insert_actived')"
                  type="primary"
                  size="medium"
                  class="vxe-btn-primary"
                  >新增银行</vxe-button
                >
                <vxe-button
                  @click="handleDelete('partnersBanks')"
                  type="primary"
                  size="medium"
                  class="vxe-btn-delete"
                >
                  {{ $t('cooperation.buttons.delete') }}</vxe-button
                >
              </template>
            </vxe-grid>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="4">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            联系信息
          </div>
        </template>
        <div class="collapse-content">
          <div class="tableStyle">
            <vxe-grid
              border
              show-overflow
              resizable
              ref="partnersPersons"
              class="vxe-table-element"
              size="mini"
              align="center"
              :auto-resize="true"
              :data="baseData.partnersPersons"
              :columns="linkColumnList"
              :toolbar="{}"
              :edit-rules="linkTableEditRules"
              :edit-config="{ trigger: 'click', mode: 'row' }"
              :valid-config="{ autoPos: true, message: 'inline' }"
            >
              <template v-slot:buttons>
                <vxe-button
                  @click="$refs.partnersPersons.commitProxy('insert_actived')"
                  type="primary"
                  size="medium"
                  class="vxe-btn-primary"
                  >新增联系人</vxe-button
                >
                <vxe-button
                  @click="handleDelete('partnersPersons')"
                  type="primary"
                  size="medium"
                  class="vxe-btn-delete"
                  >{{ $t('cooperation.buttons.delete') }}</vxe-button
                >
              </template>
            </vxe-grid>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="5">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            收货地址
          </div>
        </template>
        <div class="collapse-content">
          <!-- 收货地址表格 -->
          <div class="tableStyle">
            <vxe-grid
              border
              show-overflow
              resizable
              ref="receiveAddressTable"
              class="vxe-table-element"
              size="mini"
              align="center"
              :auto-resize="true"
              :data="baseData.consigneeAddressList"
              :columns="receiveAddressColumns"
              :toolbar="{}"
              :edit-rules="receiverAddressEditRules"
              :edit-config="{ trigger: 'click', mode: 'row' }"
              :valid-config="{ autoPos: true, message: 'inline' }"
            >
              <template v-slot:buttons v-if="!forbidden">
                <vxe-button
                  @click="$refs.receiveAddressTable.commitProxy('insert_actived')"
                  type="primary"
                  size="medium"
                  class="vxe-btn-primary"
                  >新增收货地址</vxe-button
                >
                <vxe-button
                  @click="handleDelete('receiveAddressTable')"
                  type="primary"
                  size="medium"
                  class="vxe-btn-delete"
                  >{{ $t('cooperation.buttons.delete') }}</vxe-button
                >
              </template>
            </vxe-grid>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item name="6">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件文档
          </div>
        </template>
        <div class="collapse-content">
          <FileTable
            ref="fileTableRef"
            ::attachments="baseData.partnersAttachments || []"
            :isShowDownBtn="forbidden"
          ></FileTable>
        </div>
      </el-collapse-item>
    </el-collapse>

    <!-- 扩展申请弹窗 -->
    <expand
      ref="expand"
      @clearRepeatData="clearRepeatData"
      @getExpandData="getExpandData"
      @partnerTypeChange="partnerTypeChange"
      @changeCountry="changeCountry"
    />
    <!-- 底部按钮 -->
    <footer class="bottomButtons">
      <el-button
        v-hasPermi="['2021050815340830140']"
        class="fixed-bottom-btn"
        type="primary"
        @click="save('ZT06', 'SAVE_PARNERS')"
        >{{ $t('cooperation.buttons.save') }}</el-button
      >
      <el-button
        v-hasPermi="['2021050815342448426']"
        class="fixed-bottom-btn"
        type="primary"
        @click="save('ZT02', 'SAVE_PARNERS')"
        >{{ $t('cooperation.buttons.submit') }}</el-button
      >
    </footer>
  </div>
</template>

<script>
  import API from '@/api/masterData/cooperation';
  import FileTable from '@/components/business/FileTable/index.vue';
  import BASE_API from '@/api/dataBase';
  import { mapState } from 'vuex';
  // import upload from '@/components/upload';
  import { dateTimeFormat, dateFormat } from '@/filters';
  import InputNumber from '@/components/form-item/input-number';
  import SearchTable from '@/components/form-item/search-table';
  import {
    bankTableEditRules,
    checkPhone,
    partLinkTableEditRules,
    receiverAddressEditRules,
  } from './rules/tableRules.js';

  import {
    deliverRules,
    personalRules,
    domesticEnterprisesRules,
    domesticEnterprisesCNRules,
    foreignRules,
    hrRule,
    // sellSubjectRule,
    foreignRulesParterPerson,
    foreignRulesPerson,
    // purchaseSubjectRule,
    personalRulesParter,
    domesticEnterprisesRulesParter,
    foreignRulesParter,
  } from './rules/rules';
  import Expand from './dialog/expand';
  import { toFormErrorTop } from '@/common/js/util';
  import BankSearchModel from '../components/bankSearchModel/bankSearchModel.vue';
  export default {
    name: 'addCooperation',
    components: { Expand, InputNumber, SearchTable, FileTable },
    computed: {
      bankColumnList() {
        return [
          { type: 'checkbox', width: '50' },
          {
            type: 'seq',
            title: '序号',
            visible: true,
            width: '80',
          },
          {
            field: 'bankName',
            title: this.$t('cooperation.label.bankName'),
            showHeaderOverflow: true,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{row.bankName}</span>];
              },
              edit: ({ row }) => {
                return [
                  <BankSearchModel
                    searchType="bank"
                    isMultiple={true}
                    currentValue={row['bankName']}
                    checkRowKeys={[row['bankName']]}
                    onInput={(val) => this.chooseTable(val, row)}
                  ></BankSearchModel>,
                ];
              },
            },
          },
          {
            field: 'bankCode',
            title: this.$t('cooperation.label.bankCode'),
          },
          {
            field: 'associatedLineNumber',
            title: this.$t('cooperation.label.associatedLineNumber'),
          },
          {
            field: 'accountBankBranch',
            title: this.$t('cooperation.label.accountBankBranch'),
          },
          {
            field: 'bankAccount',
            title: this.$t('cooperation.label.bankAccount'),
            editRender: {
              name: 'ElInput',
              props: { clearable: true },
              events: {
                input: (obj) => this.bankAccountInput(obj.row, obj.row['bankAccount']),
              },
            },
          },
          {
            field: 'mark',
            title: this.$t('cooperation.label.mark'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
        ];
      },
      linkColumnList() {
        return [
          { type: 'checkbox', width: '50' },

          {
            type: 'seq',
            title: '序号',
            visible: true,
            width: '80',
          },
          {
            field: 'contactPersonName',
            title: this.$t('cooperation.label.contactPersonName'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'mobilePhone',
            title: this.$t('cooperation.label.mobilePhone'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'telephone',
            title: this.$t('cooperation.label.telephone'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'job',
            title: '职位',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'faxNo',
            title: this.$t('cooperation.label.faxNo'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'email',
            title: this.$t('cooperation.label.email'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'address',
            title: this.$t('cooperation.label.address'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'mark',
            title: this.$t('cooperation.label.mark'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
        ];
      },
      // fileColumnList() {
      //   return [
      //     { type: 'checkbox', width: 50 },
      //     { field: 'attachmentName', title: this.$t('cooperation.label.attachmentName') },
      //     { field: 'createBy', title: this.$t('upload.uploader') },
      //     { field: 'gmtCreate', title: this.$t('upload.uploadDate') },
      //   ];
      // },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        // 收款方式
        // paymentList(state) {
        //   if (state.dict.dictList.length > 10) {
        //     return state.dict.dictList.find((it) => it.dictType == 'payment_method').dictList;
        //   }
        // },
        // 获取付款条件
        // receiptList(state) {
        //   if (state.dict.dictList.length > 10) {
        //     return state.dict.dictList.find((it) => it.dictType == 'payConditionPurchase').dictList;
        //   }
        // },
        // 合作伙伴类型
        partnerTypeList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'partner_type').dictList;
          }
        },
        // 国家
        countryList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'person_national').dictList;
          }
        },
        // 省
        provinceListCN(state) {
          console.log(
            'province list: ',
            state.dict.dictList.find((item) => item.dictType == 'province').dictList
          );
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'province').dictList;
          }
        },
        // 企业类型
        enterpriseTypeList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'enterprise_type').dictList;
          }
        },
        // 发票类型
        taxTypeList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'tax_type').dictList;
          }
        },
        // 邮政编码
        postCodeList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'post_code').dictList;
          }
        },
        // 法人分类
        legalEntityTypeList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'legal_entity_type').dictList;
          }
        },
        // 客户法人分类
        customerLegalEntityTypeList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'customer_legal_entity_type')
              .dictList;
          }
        },
        // 行业
        industryList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'industry_name').dictList;
          }
        },
        //纳税人分类
        taxpayerTypeList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'taxpayerType').dictList;
          }
        },
        //合作伙伴类别
        partnerFormList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'supplier_type').dictList;
          }
        },
        //是否
        yesnoList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'isAnotherPay').dictList;
          }
        },
      }),
    },
    data() {
      let newDate = dateFormat(new Date());
      const checkHasPhone = (cur, value, callback, _) => {
        const { row } = _;
        if (!row) {
          callback();
        }
        if (row.mobilePhone || row.telephone) {
          callback();
        } else {
          callback(new Error('请填写移动电话或固定电话'));
        }
      };
      const phoneValidate = {
        mobilePhone: [
          { required: true, validator: checkHasPhone, message: '请输入联系人手机号' },
          {
            validator: checkPhone,
          },
        ],
        telephone: [
          {
            required: true,
            validator: checkHasPhone,
          },
        ],
      };
      return {
        activeNames: ['1', '2', '3', '4', '5', '6'],
        receiveAddressColumns: [
          { type: 'checkbox', width: '50' },
          {
            type: 'index',
            title: '序号',
            visible: true,
            width: '80',
          },
          {
            field: 'addressAbbreviation',
            title: '地址简称',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'consigneeAddress',
            title: '收货地址',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
        ],
        showDeliverSection: false, //是否展示投送人信息模块填写
        activeNameTab: 'baseData',
        forbidden: false, // 是否禁用
        sellForbid: false,
        purchaseForbid: false,
        todayDate: newDate,
        topData: {
          companyCode: '', // 公司代码
          companyName: '', // 公司名称
          departmentCode: '', // 业务部门
          departmentName: '', //部门名称
          requestTime: '', // 申请时间
          partnerCode: '', // 合作伙伴编码
          partnerEnName: '', // 合作伙伴名称英文
          createBy: '', // 当前用户/创建人
          requestBy: '', // 申请人code,
          busnessPersonName: '', //业务负责人名称
          businessPersonNo: '', //业务负责人编码
        },
        baseData: {
          partnerForm: null,
          taxpayerType: null, //纳税人分类
          ifDomestic: null, // 国内合作伙伴
          partnerZhName: '', // 合作伙伴名称中文
          ifPersonalPartner: null, // 个人合作伙伴
          ifCreditPartner: '1', // 授信合作伙伴
          partnerType: null, // 合作伙伴类型
          identityNo: null, // 身份证号
          creditCode: null, // 统一社会信用代码
          invoiceAddress: null, // 开票地址
          invoicePhone: null, // 开票电话
          invoiceBankName: null, // 开票银行名称
          invoiceBankAccount: null, // 开票银行账号
          legalPerson: null, // 法人
          legalEntityType: null, // 法人类型
          registeredAssets: null, // 注册资本
          actualAssets: null,
          currencyType: 'CNY', // 货币种类
          establishedDate: null, // 成立日期
          // partnerParentCompanyCode: null, // 所属集团
          // searchCode: null, // 搜索简码
          // personnelIdentificationNumber: null, // 人员识别号
          tradeCurrency: 'CNY', // 交易币种
          industryName: null, // 行业
          enterpriseType: null, // 企业类型
          taxType: null, // 发票类型
          postCode: null, // 邮政编码
          province: null, // 省份
          provinceName: null,
          city: null, // 城市
          cityName: null,
          streetAddress: null, // 街道地址
          roomNo: null, // 门牌号
          mark: null, // 备注
          partnersBanks: [], // 银行表格
          partnersPersons: [], // 联系人表格
          partnersAttachments: [], // 附件表格
          applyReason: null, // 申请原因
          capacityLimitAmount: null,
          capacityLimitCurrencyCode: null,
          capacityLimitCurrencyName: null,
          isRelatedParty: 'N', //是否关联方
          partnerParentCompanyName: '本身为母公司',
          partnerParentCompanyCode: '本身为母公司',

          //新加字段
          abbreviation: '', //合作伙伴简称
          businessScope: '', //经营范围
          licenseScope: '',
          licenseValid: '',
          permitScope: '',
          registrationAuthority: '', //登记机关
          approvalTime: '', //核准日期
          businessTerm: '', //营业期限
          //投送人模块
          delivererName: '', //投送人姓名
          delivererPhone: '', //投送人电话
          delivererIdNo: '', //投送人身份证
          delivererIdDurationStart: '', //投送人身份证期限开始
          delivererIdDurationEnd: '', //投送人身份证期限结束
          delivererAddress: '', //投送人地址
          consigneeAddressList: [], //合作伙伴收货地址信息
          consigneeAddress: '', //合作伙伴收货地址信息转String,
          dataHistories: [], //历史信息,
          // associatedPartners: '', //关联合作伙伴
          // associatedPartnersCode: [], //关联合作伙伴Code
          associatedPartnerName: [],
        },
        baseData1: {
          invoiceAddress: null,
          invoicePhone: null,
          invoiceBankName: null,
          invoiceBankAccount: null,
          ifDomestic: null,
          province: null, // 省份
          provinceName: null,
          city: null, // 城市
          cityName: null,
          streetAddress: null, // 街道地址
          delivererName: null,
          delivererPhone: null,
          delivererIdNo: null,
          delivererIdDurationStart: null,
          delivererIdDurationEnd: null,
          delivererAddress: null,
          mark: null,
        },
        // salesData: {
        //   sellReconciliationSubject: '', // 对账科目
        //   sellReconciliationSubjectDesc: '', // 对账科目描述
        //   sellReceiptMethod: '', // 收款方式
        //   sellInvoiceCondition: '', // 开票条件
        //   sellInvoiceConditionDesc: '', // 销售开票条件描述
        // },
        // purchasingData: {
        //   procurementReconciliationSubject: '', // 对账科目
        //   procurementReconciliationSubjectDesc: '', // 对账科目描述
        //   procurementReceiptMethod: '', // 收款方式
        //   procurementPayCondition: '', // 付款条件
        //   procurementPayConditionDesc: '', // 付款条件描述
        //   procurementCurrency: '', // 订单货币
        //   procurementDepositAmount: '', // 保证金金额
        // },
        bankTableEditRules: bankTableEditRules, // 银行表格校验规则
        linkTableEditRules: Object.assign({}, partLinkTableEditRules, phoneValidate), // 联系人校验规则
        receiverAddressEditRules: receiverAddressEditRules, //收货地址规则
        hrRules: [], // hr员工校验规则
        // sellSubjectRule: [], // 销售数据对账科目校验规则
        // purchaseSubjectRule: [], // 采购数据对账科目校验规则
        // subjectList: [], // 对账科目销售
        // subjectProcureList: [], //采购
        requestByList: [], // 申请人数据
        departmentList: [], // 部门数据
        checkPartner: [], // 查重返回结果
        provinceList: [], //省份
        cityList: [], // 城市下拉数据
        tradeCurrencyList: [], // 交易币种下拉数据
        legalList: [], // 法人分类数据
        groupList: [], // 所属集团列表
        time: null, // 定时器
        rules: {}, // 校验规则
        ossUrl: '', // 附件上传地址
        ossData: {}, // 附件上传参数
        rules1: {
          invoiceAddress: [
            {
              required: true,
              message: '请输入开票地址',
              trigger: ['blur', 'change'],
            },
          ],
          invoicePhone: [
            {
              required: true,
              message: '请输入开票电话',
              trigger: ['blur', 'change'],
            },
          ],
          invoiceBankName: [
            {
              required: true,
              message: '请输入开票银行名称',
              trigger: ['blur', 'change'],
            },
          ], // 开票银行名称
          invoiceBankAccount: [
            {
              required: true,
              message: '请输入开票银行账号',
              trigger: ['blur', 'change'],
            },
          ], // 开票银行账号
          ifDomestic: [
            {
              required: true,
              message: '请选择国家地区',
              trigger: ['blur', 'change'],
            },
          ],
          province: [{ required: true, message: '请选择省', trigger: ['blur', 'change'] }],
          city: [{ required: true, message: '请选择市', trigger: ['blur', 'change'] }],
        },
      };
    },
    mounted() {
      this.legalList = this.legalEntityTypeList;
      this.startTime();
      this.getData();
      this.getDictList();
      this.changeRules(domesticEnterprisesRules); // 校验规则初始化为国内企业
      this.baseData.ifDomestic = this.$globalVar.CHNCode;
      this.initCountryData(this.baseData.ifDomestic);
    },
    // beforeDestroy() {
    //   clearInterval(this.time); // 清除定时器
    // },
    methods: {
      // 禁止输入空格
      avoidBlank(value) {
        if (value) {
          value = value.replace(/\s+/g, '');
        }
        return value;
      },
      // 银行信息-银行账户
      bankAccountInput(row, value) {
        row.bankAccount = this.avoidBlank(value);
      },
      // 开票信息-开票银行账户
      invoiceBankAccountInput(value) {
        this.baseData1.invoiceBankAccount = this.avoidBlank(value);
      },
      // 关闭的时候数据校验
      // async closeEditTableHandler(tableRef) {
      //   const $table = this.$refs[tableRef];
      //   const errMap = await $table.validate().catch((errMap) => errMap);
      //   if (errMap) {
      //     this.$message.error('请检查数据再提交');
      //   } else {
      //     await $table.clearActived();
      //   }

      //   if (tableRef == 'receiveAddressTable') {
      //     if (this.checkAddressRepeat()) {
      //       this.$message({ showClose: true, message: '地址简称重复！', type: 'error' });
      //     }
      //   }
      // },
      formatPartnerName() {
        if (this.baseData.partnerZhName) {
          this.baseData.partnerZhName = this.baseData.partnerZhName.trim().replace(/\s/gi, '-');
        }
      },
      checkAddressRepeat() {
        let consigneeAddressList = this.$refs.receiveAddressTable.getTableData().fullData;
        let tempAddress = '';
        let repeat = false;
        //检查简称是否重复
        if (consigneeAddressList) {
          consigneeAddressList.forEach((item) => {
            console.log('addressItem', item);
            if (item.addressAbbreviation == tempAddress) {
              repeat = true;
            } else {
              tempAddress = item.addressAbbreviation;
            }
          });
        }
        return repeat;
      },
      changeRelated(val) {
        console.log(val);
      },
      changeDearptment(val) {
        this.topData.departmentName = this.departmentList.find(
          (it) => it.personDepartmentCode == val
        ).personDepartmentName;
      },
      //表格组件下拉框选择回调
      getSelectLabel(value) {
        let item = this.tradeCurrencyList.find((item) => {
          return value == item.value;
        });
        return item ? item.label : null;
      },
      //获取值
      chooseTable(val, row) {
        row.bankName = val[0].bankName || '-';
        row.bankCode = val[0].bankCode || '-';
        row.associatedLineNumber = val[0].bankUnionNumber || '-';
        row.accountBankBranch = val[0].branchName || '-';
      },
      getData() {
        console.log('userinfo: ', this.userinfo);
        this.topData.companyCode = this.userInfo.companyCode;
        this.topData.companyName = this.userInfo.companyName;
        this.topData.departmentCode = this.userInfo.departmentCode;
        this.topData.departmentName = this.userInfo.departmentName;
        this.topData.requestBy = Number(this.userInfo.userCode);
        this.topData.requestByName = this.userInfo.userName;
        this.activeNameTab = 'baseData';
      },
      // 合作伙伴类型切换
      partnerTypeChange(value) {
        console.log('partnerTypeChange', value);
        value = value || this.baseData.partnerType;
        // this.baseData.legalEntityType = "";
        value == 'HZHB01' || value === 'HZHB10'
          ? (this.legalList = this.customerLegalEntityTypeList)
          : (this.legalList = this.legalEntityTypeList); // 判断法人类型下拉
        this.hrRules = value == 'HZHB04' ? hrRule : []; // hr员工,人员识别号必填
        this.showDeliverSection = value === 'HZHB13';
        if (value === 'HZHB01' || value === 'HZHB10') {
          // 客户  "HZHB10"
          // this.sellSubjectRule = sellSubjectRule;
          // this.sellForbid = false;
          // // this.purchaseSubjectRule = [];
          // this.purchaseForbid = true;
          // this.$refs.purchasingData.resetFields();
        }
        // else if (value === "HZHB02") { // 供应商
        //   this.sellSubjectRule = [];
        //   this.sellForbid = true;
        //   this.$refs.salesData.resetFields();
        //   this.purchaseSubjectRule = purchaseSubjectRule;
        //   this.purchaseForbid = false;
        // }
        else if (value === 'HZHB03' || value === 'HZHB11') {
          // 合作伙伴  集团内部客户和供应商
          // this.sellSubjectRule = sellSubjectRule;
          // this.sellForbid = false;
          // this.purchaseSubjectRule = purchaseSubjectRule;
          // this.purchaseForbid = false;
        } else {
          // 其他
          // this.sellSubjectRule = sellSubjectRule;
          // this.purchaseSubjectRule = [];
          // this.sellSubjectRule = [];
          // this.sellForbid = true;
          // this.$refs.salesData.resetFields();
          // this.purchaseSubjectRule = purchaseSubjectRule;
          // this.purchaseForbid = false;
        }
        if (value != 'HZHB07') {
          this.baseData.capacityLimitCurrencyCode = null;
          this.baseData.capacityLimitCurrencyName = null;
          this.baseData.capacityLimitAmount = null;
        }
        this.resolveRules();
      },
      debounce(func, delay = 300, immediate = false) {
        let timer = null;
        return function () {
          if (timer) {
            clearTimeout(timer);
          }
          if (immediate && !timer) {
            func.apply(this, arguments);
          }
          timer = setTimeout(() => {
            func.apply(this, arguments);
          }, delay);
        };
      },
      // 身份证/社会统一代码校验去重
      handleInputHover(value) {
        let params = {
          creditCode: this.baseData.creditCode,
          identityNo: this.baseData.identityNo,
          // partnerZhName: this.baseData.partnerZhName,
          departmentCode: this.userInfo.departmentCode, // 查询当前部门是否重复
          requestStatus: 'ZT03', //【ID1002169】 只有已生效的可以扩展【合作伙伴主数据】已驳回状态仍可以扩展
        };
        // 本部门查重
        this.$axios.post(API.GET_CHECKING_PARTNER, params).then((res) => {
          if (res.data.code === 0) {
            if (res.data.data.length === 0) {
              // 全范围查重
              delete params.departmentCode;
              this.$axios.post(API.GET_CHECKING_PARTNER, params).then((res) => {
                if (res.data.code === 0) {
                  this.checkPartner = res.data.data;
                  this.handleExpand(this.checkPartner, value);
                }
              });
            } else {
              this.$confirmAction(this.$t('cooperation.message.data_repeat'), '')
                .then(() => {
                  // this.returnPath();
                })
                .catch(() => {
                  this.clearRepeatData(value);
                });
            }
          }
        });
      },
      //申请人
      setRequestPerson(row) {
        this.topData.requestBy = row ? row[0].id : null;
        this.topData.requestByName = row ? row[0].personName : null;
      },
      setBusinessPerson(row) {
        this.topData.busnessPersonName = row ? row[0].personName : null;
        this.topData.businessPersonNo = row ? row[0].id : null;
      },
      // // 所属集团
      // setPartnerParent(row) {
      //   this.baseData.partnerParentCompanyCode = row ? row[0].partnerCode : '本身为母公司';
      //   this.baseData.partnerParentCompanyName = row ? row[0].partnerZhName : '本身为母公司';
      // },
      // setAssociatePartner(row) {
      // var list = [];
      // row.forEach(function (e) {
      //   list.push({ partnerZhName: e.partnerZhName, partnerCode: e.partnerCode });
      // });
      // this.baseData.associatedPartnerName = list;
      // console.log('output', list);
      // },
      // 取消扩展操作删除重复数据
      clearRepeatData(value) {
        this.baseData[value] = ''; // 清空数据
      },
      // 打开扩展提醒弹窗
      handleExpand(checkPartner, value) {
        if (this.checkPartner.length > 0) {
          this.$confirmAction(this.$t('cooperation.message.is_expand_apply'), '')
            .then(() => {
              let companyInfo = {
                companyName: this.topData.companyName,
                companyCode: this.topData.companyCode,
                departmentName: this.topData.departmentName,
                departmentCode: this.topData.departmentCode,
              };
              this.$refs.expand.openDialog(
                this.checkPartner[0],
                this.partnerTypeList,
                value,
                this.departmentList,
                companyInfo
              );
            })
            .catch(() => {
              this.clearRepeatData(value);
            });
        }
      },
      // 获取扩展的数据
      getExpandData(data) {
        data.partnerType == 'HZHB01'
          ? (this.legalList = this.customerLegalEntityTypeList)
          : (this.legalList = this.legalEntityTypeList);
        this.topData.partnerCode = data.partnerCode;
        this.baseData.partnerZhName = data.partnerZhName;
        this.topData.partnerEnName = data.partnerEnName;
        Object.keys(this.baseData).forEach((item) => {
          this.baseData[item] = data[item];
        });
        this.forbidden = true;
        this.resolveRules();
      },
      save(type, api) {
        let _self = this;
        let baseDataFlag = true;
        let topDataFlag = true;
        let promiseObjectList = [];
        function validates(formName) {
          let promiseObject = new Promise((resolve, reject) => {
            if (
              formName === 'partnersBanks' ||
              formName === 'partnersPersons' ||
              formName === 'receiveAddressTable'
            ) {
              _self.$refs[formName]
                .validate()
                .then(() => {
                  resolve();
                })
                .catch(() => {
                  reject(formName);
                });
            } else {
              _self.$refs[formName].validate((valid) => {
                if (valid) {
                  resolve();
                } else {
                  reject(formName);
                }
              });
            }
          });
          promiseObjectList.push(promiseObject);
        }

        if (!this.topData.companyName || this.topData.companyName.length == '') {
          topDataFlag = false;
        }
        if (!this.topData.departmentCode || this.topData.departmentCode.length == '') {
          topDataFlag = false;
        }

        const formList = [
          'topData',
          'baseData',
          'baseData1',
          'partnersBanks',
          'partnersPersons',
          'receiveAddressTable',
          // 'salesData',
          // 'purchasingData',
        ];
        if (type === 'ZT06') {
          this.$refs.baseData.validateField('partnerType', (valid) => {
            if (valid.length > 0) {
              baseDataFlag = false;
            } else {
              baseDataFlag = true;
            }
          });
          this.$refs.baseData.validateField('partnerZhName', (valid) => {
            if (valid.length > 0) {
              topDataFlag = false;
            } else {
              topDataFlag = true;
            }
          });
        } else {
          formList.forEach((item) => {
            validates(item);
          });
        }
        if (!topDataFlag || !baseDataFlag) {
          toFormErrorTop();
          return;
        }

        if (this.checkAddressRepeat()) {
          this.$message({ showClose: true, message: '地址简称重复！', type: 'error' });
          return;
        }
        // 合并对象
        let params = Object.assign(this.topData, this.baseData, this.baseData1);
        params = Object.assign(params, this.salesData);
        params = Object.assign(params, this.purchasingData);
        params.partnersBanks = this.$refs.partnersBanks.getTableData().fullData;
        params.partnersPersons = this.$refs.partnersPersons.getTableData().fullData;
        params.consigneeAddressList = this.$refs.receiveAddressTable.getTableData().fullData;
        Promise.all(promiseObjectList)
          .then(() => {
            if (type === 'ZT02' && this.userInfo.adminFlag == 1) {
              // 判断用户角色
              params.requestStatus = 'ZT07';
            } else {
              params.requestStatus = type;
            }
            params.partnersBanks = JSON.stringify(params.partnersBanks);
            params.partnersPersons = JSON.stringify(params.partnersPersons);
            params.partnersAttachments = this.$refs.fileTableRef.getTableData();
            params.partnersAttachments = JSON.stringify(params.partnersAttachments);
            params.consigneeAddress = JSON.stringify(params.consigneeAddressList);
            if (params.associatedPartnerName && params.associatedPartnerName.length != 0) {
              params.associatedPartnerName = JSON.stringify(
                params.associatedPartnerName.map((item) => {
                  return { partnerCode: item.partnerCode, partnerZhName: item.partnerZhName };
                })
              );
            } else {
              params.associatedPartnerName = null;
            }
            // 新增字段
            params.partnerCompanyName = params.companyName;
            params.partnerCompanyCode = params.companyCode;
            params.tenantCode = this.userInfo.tenantCode;
            // params.requestCreateBy = params.createBy;
            var obj = this.requestByList.find((item) => {
              return item.personName == this.topData.createBy;
            });
            params.requestCreateBy = obj ? obj.id : this.topData.createBy;

            //新加字段
            params.abbreviation = this.baseData.abbreviation; //合作伙伴简称
            params.businessScope = this.baseData.businessScope; //经营范围
            params.licenseScope = this.baseData.licenseScope; //经营范围
            params.licenseValid = this.baseData.licenseValid;
            params.permitScope = this.baseData.permitScope; //经营范围
            params.registrationAuthority = this.baseData.registrationAuthority; //登记机关
            params.approvalTime = this.baseData.approvalTime; //核准日期
            params.businessTerm = this.baseData.businessTerm; //营业期限
            //投送人模块
            params.delivererName = this.baseData.delivererName; //投送人姓名
            params.delivererPhone = this.baseData.delivererPhone; //投送人电话
            params.delivererIdNo = this.baseData.delivererIdNo; //投送人身份证
            params.delivererIdDurationStart = this.baseData.delivererIdDurationStart; //投送人身份证期限
            params.delivererIdDurationEnd = this.baseData.delivererIdDurationEnd; //投送人身份证期限
            params.delivererAddress = this.baseData.delivererAddress; //投送人地址

            this.loading.startLoading();
            this.$axios.post(API[api], params).then((res) => {
              this.loading.endLoading();
              if (res.data.code === 0) {
                if (type === 'ZT06') {
                  this.dblclickEvent(res.data.data);
                } else {
                  /* if(this.userInfo.adminFlag == 1&&api === 'SAVE_PARNERS'){
        this.commitSave(res.data.data);
    }else{ */
                  this.returnPath();
                  // }
                }
                this.$message({ showClose: true, message: res.data.msg, type: 'success' });
              } else {
                // this.returnPath();
                this.$message({ showClose: true, message: res.data.msg, type: 'error' });
              }
            });
          })
          .catch((err) => {
            console.log('error', err);
            if (err == 'baseData' || err == 'salesData' || err == 'purchasingData') {
              this.activeNameTab = err;
            } else {
              this.activeNameTab = 'baseData';
            }
            let message = this.$t('cooperation.message.topFormCheckResult');

            if (err == 'partnersBanks') {
              message = '请检查银行表格';
            } else if (err == 'partnersPersons') {
              message = '请检查联系人表格';
            } else if (err == 'receiveAddressTable') {
              message = '请检查收货地址表格';
            }

            this.loading.endLoading();
            toFormErrorTop();
            this.$message({
              showClose: true,
              message: message,
              type: 'error',
            });
          });
      },
      //提交完调mdg 管理员
      // commitSave(data) {
      //   // 合并对象
      //   let params = data;
      //   params.requestStatus = 'ZT03';
      //   params.partnersBanks = JSON.stringify(params.partnersBanks);
      //   params.partnersPersons = JSON.stringify(params.partnersPersons);
      //   params.partnersAttachments = JSON.stringify(params.partnersAttachments);
      //   params.consigneeAddress = JSON.stringify(params.consigneeAddressList);
      //   params.associatedPartnerName = JSON.stringify(params.associatedPartnerName);
      //   // 新增字段
      //   params.partnerCompanyName = params.companyName;
      //   params.partnerCompanyCode = params.companyCode;
      //   params.tenantCode = this.userInfo.tenantCode;
      //   params.requestCreateBy = params.createBy;
      //   params.id = params.extendId;

      //   //新加字段
      //   params.abbreviation = this.baseData.abbreviation; //合作伙伴简称
      //   params.businessScope = this.baseData.businessScope; //经营范围
      //   params.registrationAuthority = this.baseData.registrationAuthority; //登记机关
      //   params.approvalTime = this.baseData.approvalTime; //核准日期
      //   params.businessTerm = this.baseData.businessTerm; //营业期限
      //   //投送人模块
      //   params.delivererName = this.baseData.delivererName; //投送人姓名
      //   params.delivererPhone = this.baseData.delivererPhone; //投送人电话
      //   params.delivererIdNo = this.baseData.delivererIdNo; //投送人身份证
      //   params.delivererIdDurationStart = this.baseData.delivererIdDurationStart; //投送人身份证期限
      //   params.delivererIdDurationEnd = this.baseData.delivererIdDurationEnd; //投送人身份证期限
      //   params.delivererAddress = this.baseData.delivererAddress; //投送人地址

      //   this.loading.startLoading();
      //   this.$axios.post(API.PARTNER_SYNCMDG, params).then((res) => {
      //     this.loading.endLoading();
      //     if (res.data.code === 0) {
      //       this.returnPath();
      //       this.$message({ showClose: true, message: res.data.msg, type: 'success' });
      //     } else {
      //       this.returnPath();
      //       this.$message({ showClose: true, message: res.data.msg, type: 'error' });
      //     }
      //   });
      // },
      // // 开启实时
      startTime() {
        // this.time = setInterval(()=>{
        this.topData.requestTime = dateTimeFormat(new Date(), true);
        // }, 1000)
      },
      //返回详情
      dblclickEvent(value) {
        let path = {
          fromPath: {
            path: '/masterData/addCooperation',
            name: 'addCooperation',
            meta: {
              keepAlive: true,
              title: this.$t('cooperation.route.addCooperation'),
            },
          },
          toPath: {
            path: '/masterData/editCooperation',
            name: 'editCooperation',
            meta: {
              keepAlive: false,
              title: this.$t('cooperation.route.editCooperation'),
            },
            query: {
              id: value.extendId,
              partnerCode: value.partnerCode,
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      // 返回列表页
      returnPath() {
        let path = {
          fromPath: {
            path: '/masterData/addCooperation',
            name: 'addCooperation',
            meta: {
              keepAlive: true,
              title: this.$t('cooperation.route.addCooperation'),
            },
          },
          toPath: {
            path: '/masterData/cooperation',
            name: 'cooperation',
            meta: {
              keepAlive: false,
              title: this.$t('cooperation.route.cooperation'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //国家切换 => 获取省份
      changeCountry(value) {
        console.log(value);
        this.baseData1.province = !value ? this.baseData1.province : '';
        this.baseData1.city = !value ? this.baseData1.city : '';
        if (!value) this.changeProvince();
        value = value || this.baseData1.ifDomestic;
        if (this.baseData1.ifDomestic == this.$globalVar.CHNCode) {
          this.provinceList = { ...this.provinceListCN };
          return;
        }
        this.$axios.post(BASE_API.QUERY_PROVICE + '?parentAreaNo=' + value, {}).then((res) => {
          if (res.data.code === 0) {
            this.provinceList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      initCountryData(value) {
        this.$axios.post(BASE_API.QUERY_PROVICE + '?parentAreaNo=' + value, {}).then((res) => {
          if (res.data.code === 0) {
            this.provinceList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },

      changeProvince(value) {
        this.baseData1.city = !value ? this.baseData1.city : '';
        value = value || this.baseData1.province;
        this.$axios.post(BASE_API.QUERY_CITY + '?parentAreaNo=' + value, {}).then((res) => {
          if (res.data.code === 0) {
            this.cityList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 省份切换 => 获取城市
      handleProvinceChange(val) {
        this.baseData1.city = null;
        if (val && val.length) {
          console.log(this.provinceList, '11??');
          let name = this.provinceListCN.find((item) => item.value == val).label;
          if (name && name.length) {
            this.baseData1.provinceName = name;
          }
          console.log('provinceChange', this.baseData.provinceName, this.baseData.province);
          this.$axios.post(BASE_API.QUERY_CITY + '?parentAreaNo=' + val, {}).then((res) => {
            if (res.data.code === 0) {
              this.cityList = res.data.data;
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        }
      },
      handleCityChange(val) {
        if (val && val.length) {
          let name = this.cityList.find((item) => item.value == val).label;
          if (name && name.length) {
            this.baseData1.cityName = name;
          }
          console.log('cityChange', this.baseData1.cityName, this.baseData1.city);
        }
      },
      // 改变校验规则
      changeRules(baseRules) {
        // this.rules = rules;
        console.log('baseRules', baseRules, deliverRules);
        let result = { ...baseRules, ...deliverRules };

        // debugger;

        let invoiceRequired = true;
        if (this.baseData.ifPersonalPartner == '1') {
          invoiceRequired = false;
        } else {
          if (this.baseData.taxType == '2') {
            invoiceRequired = false;
          }
        }
        //供应商HZHB02
        if (this.baseData.partnerType && this.baseData.partnerType == 'HZHB02') {
          invoiceRequired = false;
        }
        console.log('改变校验规则');
        Object.keys(result).forEach((key) => {
          if (
            key == 'invoiceAddress' ||
            key == 'invoicePhone' ||
            key == 'invoiceBankName' ||
            key == 'invoiceBankAccount'
          ) {
            if (invoiceRequired) {
              result[key][0].required = true;
            } else {
              result[key][0].required = false;
            }
          }
        });
        this.rules = result;

        // const componentsList = ['topData', 'baseData', 'salesData', 'purchasingData'];
        const componentsList = ['topData', 'baseData', 'baseData1'];
        this.$nextTick(() => {
          componentsList.forEach((item) => {
            this.$refs[item].clearValidate();
          });
        });
      },
      //库容限额选择币种获取中文
      capacityLimitCurrency(val) {
        this.baseData.capacityLimitCurrencyName = val
          ? this.tradeCurrencyList.find((item) => {
              return val == item.value;
            }).label
          : '';
      },
      // 判断校验规则
      resolveRules(val, type) {
        const { ifDomestic, ifPersonalPartner } = this.baseData;
        let arr = ['HZHB01', 'HZHB10', 'HZHB03', 'HZHB11'];
        //合作伙伴主数据中国、中国保税区、中国香港、中国台湾、中国澳门必填，省份城市字段从非必填改为必填
        let arrCN = ['HK', 'TW', 'MO', 'ZH'];
        let flag = arr.find((item) => item == this.baseData.partnerType);
        let flagCN = arrCN.find((item) => item == this.baseData.ifDomestic);
        if (ifDomestic == this.$globalVar.CHNCode) {
          // if (ifPersonalPartner == 1) {
          //   this.changeRules(personalRules) // 国内个人校验规则
          // } else {
          //   this.changeRules(domesticEnterprisesRules) // 国内企业校验规则
          // }
          //fixme
          if (ifPersonalPartner == 1) {
            this.baseData.creditCode = null;
          } else {
            this.baseData.identityNo = null;
          }
          if (ifPersonalPartner == 1 && !flag) {
            //国内个人校验
            this.changeRules(personalRules);
            console.log('国内个人');
          } else if (ifPersonalPartner != 1 && !flag) {
            //国内企业校验
            this.changeRules(domesticEnterprisesRules);
            console.log('国内企业');
          } else if (ifPersonalPartner == 1 && flag) {
            //国内个人甲和合作伙伴
            this.changeRules(personalRulesParter);
            console.log('国内合作伙伴');
          } else if (ifPersonalPartner != 1 && flag) {
            //国内企业加合作伙伴
            this.changeRules(domesticEnterprisesRulesParter);
            console.log('国内企业加合作伙伴');
          }
        } else {
          console.log('other rules');
          if (!flag) {
            if (ifPersonalPartner == 1) {
              this.changeRules(foreignRules); // 国外个人校验规则
              console.log('国外个人');
            } else {
              this.changeRules(foreignRulesPerson); //国外企业
              console.log('国外企业');
            }
          } else {
            if (ifPersonalPartner == 1) {
              this.changeRules(foreignRulesParter); // 国外校验规则+合作伙伴+个人
              console.log('国外合作伙伴');
            } else {
              this.changeRules(foreignRulesParterPerson); // 国外校验规则+合作伙伴+企业
              console.log('国外合作伙伴企业');
            }
          }
        }
        if (type == 'ifDomestic') {
          this.changeCountry(val);
        }
        if (flagCN) {
          //国内企业校验
          this.changeRules(domesticEnterprisesCNRules);
        }
      },
      // 附件上传
      // handleUpload(uploadTableData) {
      //   console.log(uploadTableData, '---??');
      //   this.baseData.partnersAttachments = uploadTableData;
      // },
      // 删除
      handleDelete(tableTpye) {
        const selectedList = this.$refs[tableTpye].getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('cooperation.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs[tableTpye].removeSelecteds();
            this.baseData[tableTpye] = this.$refs[tableTpye].getTableData().fullData;
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('cooperation.message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('cooperation.message.cancelled'),
            });
          });
      },
      // 获取字典值
      async getDictList() {
        const { tenantCode } = this.userInfo;

        // 获取部门数据
        let res1 = await this.$axios.post(API.GET_LIST_PERSON, {
          id: this.userInfo.userCode,
          personCompanyCode:
            this.topData.companyCode.length != 0
              ? this.topData.companyCode
              : this.userInfo.companyCode,
        });
        if (res1.data.code === 0) {
          this.departmentList = res1.data.data.personDepartmentInfo;
        }
        // 获取用户数据
        let res2 = await this.$axios.post(API.GET_LIST_PERSON, { personInfo: '' });
        if (res2.data.code === 0) {
          this.requestByList = res2.data.data.personInfo;
          this.topData.createBy = this.requestByList.find(
            (item) => item.id == this.userInfo.userCode
          ).personName;
        }
        // 交易币种（币种管理）
        this.$baseRequest.getCurrency().then((res) => {
          this.tradeCurrencyList = [];
          if (res.length > 0) {
            res.map((item) => {
              item['value'] = item.currencyCode;
              item['label'] = item.currencyName;
              this.tradeCurrencyList.push(item);
            });
          }
        });
        // 对账科目
        // this.$baseRequest.getAccountListByCompanyCode(companyCode).then(res=>{
        //   this.subjectList = res;
        // })
        //销售数据对帐
        this.$axios
          .post(API.DICT_LIST, { dictType: 'generalLedgerAccountSales', tenantCode: tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.subjectList = res.data.data;
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        //采购数据对账
        this.$axios
          .post(API.DICT_LIST, { dictType: 'generalLedgerAccountPurchase', tenantCode: tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.subjectProcureList = res.data.data;
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
      },
      // 合作伙伴名称变化
      getPartnerName(val) {
        this.$axios.post(`${API.GET_PARTNER_GROUP}`, { partnerName: val }).then((res) => {
          console.log(res.data);
          if (res.data.code === 0) {
            if (res.data.data) {
              this.baseData.partnerParentCompanyName = res.data.data.partnerZhName;
              this.baseData.partnerParentCompanyCode = res.data.data.partnerCode;
              this.$axios.get(`${API.IS_EXIST_BY_NAME}?partnerZhName=${val}`).then((res) => {
                if (res.data.code === 0) {
                  if (res.data.data) {
                    this.$message({ showClose: true, message: res.data.msg, type: 'error' });
                    this.debounce(this.handleInputHover('partnerName'), 2000);
                  }
                } else {
                  this.$alert(res.data.msg);
                }
              });
            }
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 销售数据对账科目变化
      // sellReconciliationSubjectChange(value) {
      //   if (value) {
      //     this.salesData.sellReconciliationSubjectDesc = value;
      //     this.$refs.salesData.clearValidate('sellReconciliationSubject');
      //   } else {
      //     this.salesData.sellReconciliationSubjectDesc = '';
      //   }
      // },
      // 采购数据对账科目变化
      // procurementReconciliationSubjectChange(value) {
      //   if (value) {
      //     this.purchasingData.procurementReconciliationSubjectDesc = value;
      //     this.$refs.purchasingData.clearValidate('procurementReconciliationSubject');
      //   } else {
      //     this.purchasingData.procurementReconciliationSubjectDesc = '';
      //   }
      // },
    },
  };
</script>
<style>
  .addCooperation .isShowLabel .el-form-item__content {
    margin-left: 0 !important;
  }

  .addCooperation .textOver label {
    line-height: unset;
  }

  .addCooperation .dateInput .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: unset !important;
  }
</style>
<style scoped lang="scss">
  .topData {
    padding: 15px 0;
  }

  .addCooperation {
    padding-bottom: 100px;
  }

  .bottomButtons {
    padding-top: 20px;
    text-align: center;
  }

  .addCooperation .el-select,
  .el-input {
    width: 100%;
  }
  .province-city {
    ::v-deep {
      .el-form-item__label {
        width: 80px !important;
      }
      .el-form-item__content {
        margin-left: 80px !important;
      }
    }
    .isShowLabel {
      ::v-deep {
        .el-form-item__content {
          margin-left: 0px !important;
        }
      }
    }
  }
</style>
